import { generateIconComponent } from './icons.utils';

export const CloseIcon = generateIconComponent({
    name: 'CloseIcon',
    viewBox: '0 0 24 24',
    path: (
        <>
            <path d="M0.813708 2.80761C0.227922 2.22183 0.227922 1.27208 0.813708 0.686292C1.39949 0.100505 2.34924 0.100505 2.93503 0.686292L23.4411 21.1924C24.0269 21.7782 24.0269 22.7279 23.4411 23.3137C22.8553 23.8995 21.9056 23.8995 21.3198 23.3137L0.813708 2.80761Z" />
            <path d="M21.3198 0.686292C21.9056 0.100505 22.8553 0.100505 23.4411 0.686292C24.0269 1.27208 24.0269 2.22183 23.4411 2.80761L2.93503 23.3137C2.34924 23.8995 1.39949 23.8995 0.813708 23.3137C0.227921 22.7279 0.227921 21.7782 0.813708 21.1924L21.3198 0.686292Z" />
        </>
    ),
});
